import { formattingMonth } from '../../../../common/utils/date';

export const generateTitle = (position: number, date: string, name: string) => {
  switch (position) {
    case 1:
      return name + ' — лидер рейтинга агентств недвижимости по итогам ' + formattingMonth(date) + ' года';
    case 2:
    case 3:
      return `"${name}" входит в топ-3 рейтинга агентств недвижимости по итогам ${formattingMonth(date)} года`;
    default:
      return `"${name}" входит в рейтинг агентств недвижимости по итогам ${formattingMonth(date)} года`;
  }
};
